<template>
  <div  class="content">
    <el-form :label-position="labelPosition" label-width="180px" :model="formInfo" ref="formInfo" :rules="rules"
             v-loading="loading"
             element-loading-text="The input data is being submitted, please wait……">
      <el-form-item label="1. Please upload the file for your generation." >

        <el-button round type="success" plain @click="show()">Show example.phar</el-button>
<!--        <el-button round type="success" plain @click="showEdgep()">Show example.edgep</el-button>-->
        <br>

        <el-upload
            class="upload-demo"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            action=""
            :http-request="httpRequest"
            :before-remove="beforeRemove"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="formInfo.fileList">
          <el-button style="margin-top: 5px" type="primary">Click to upload .phar file</el-button>
<!--          <el-button round type="success" plain @click="show()">Show example.phar</el-button>-->
        </el-upload>

      </el-form-item>
      <el-form-item label="2. Enter the number of molecules you want to generate(optional, max = 100)."
                    prop="moleculesNumber"
      >
        <el-input v-model.number="formInfo.moleculesNumber"></el-input>
      </el-form-item>
      <el-form-item label="3. Please leave your email address and we will send the generated results to your email."
                    prop="email"

      >
        <el-input v-model="formInfo.email"></el-input>
        <span style="font-size: 12px; color: #909399; line-height: 1.5; display: block; margin-top: 4px;">
          Your uploaded data are used only for this task and are not shared or used for any other purpose. They are temporarily stored on our private server for up to six months.
        </span>
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" @click="submitForm">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
var sid=""
export default {
  data() {
    return {
      loading:false,
      sid:sid,
      labelPosition: 'top',
      formInfo: {
        fileList: [],
        moleculesNumber: 20,
        email: ''
      },
      rules: {
        moleculesNumber: [
          // { message: 'The number of molecules cannot be empty'},
          {type: 'number', min:0,max:100,message: 'The number of molecules should be numerical.Range: 0~100.'}
        ],
        email: [
          {message: 'Please input the email address.', trigger: 'blur'},
          {type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change']}
        ]
      }
    };
  },
  methods: {
    showPosp(){

      window.open("example.posp")
    },
    showEdgep(){

      window.open("example.edgep")
    },
    show(){

        window.open("example.phar")
    },
    handleRemove(file, fileList) {
      this.formInfo.fileList.pop();
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The current limit is 1 file selected`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Confirmed to remove ${file.name}?`);
    },
    httpRequest(param) {
      console.log(param);
      console.log(param.file.name);

      const fileName = param.file.name;
      const suffix = ".phar";
      if (fileName.toLowerCase().endsWith(suffix.toLowerCase()))
      {
        this.formInfo.fileList.push(param.file);
      }
      else
      {

        this.formInfo.fileList.pop();
        // 弹出一个带有消息的警告框
        return this.$confirm(`Please upload a phar type file.`);
      }
    },
    submitForm() {

      const formData = new FormData();
      if (this.formInfo.fileList.length == 0) {
        this.$alert('Please upload your .phar file.');
        this.loading = false
        return;
      } else if (parseInt(this.formInfo.moleculesNumber) > 100) {
        this.$alert('Please reset the number of molecules');
        this.loading = false
        return;
      }

      this.$refs['formInfo'].validate((valid) => {
        if (valid) {
          this.loading = true
          sid = require('uuid').v1()//生成uuid
          console.log('submit');
          formData.append("file", this.formInfo.fileList[0], this.formInfo.fileList[0].name);
          formData.append("num", this.formInfo.moleculesNumber);
          if(this.formInfo.email=='')
          {
            this.formInfo.email="2659381657@qq.com"
          }
          formData.append("email", this.formInfo.email);
          formData.append("uid", sid);
          // TODO: change url!!
          axios.post("/generation/phar", formData).then(res => {
            this.loading = false
            console.log(res.data);
            var that = this
            if (res.data.code === 403) {
              console.log(this.$alert)
              that.$alert(res.data.msg, "Tips", {
                confirmButtonText: 'Ok',
                callback: action => {
                  that.$router.push({
                    path: '/generation/success',
                    query: {
                      sid: sid
                    }
                  })
                }
              });
              return false;
            } else {
              this.$router.push({
                path: '/generation/success',
                query: {
                  sid: sid
                }
              })
            }
          }).catch(err => {
            console.log(err);
            this.$alert('Submit fails!')
          })
        } else {
          this.loading = false
          console.log('error submit!!');
          return false;
        }
      })
      // console.log(formData);
    },

  }
}
</script>

<style scoped>
.el-form-item {
  text-align: left;
}

.submit {
  text-align: center;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
